module.exports = "http://cdn.realive.com.ua/src/views/games/other/images/roles/civilian_man.png";